// SPDX-FileCopyrightText: Copyright (C) 2026 provide.io llc
// SPDX-License-Identifier: Apache-2.0
import { type ReactElement, useEffect } from "react";
import { useAuth } from "react-oidc-context";
import { useNavigate } from "react-router";

export function AuthCallback(): ReactElement {
  const auth = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    if (!auth.isLoading && !auth.error) navigate("/", { replace: true });
  }, [auth.isLoading, auth.error, navigate]);
  if (auth.error) {
    return (
      <div className="mx-auto max-w-lg p-8">
        <h1 className="mb-2 font-semibold text-xl">Sign-in failed</h1>
        <p className="text-muted-foreground text-sm">{auth.error.message}</p>
      </div>
    );
  }
  return <div className="p-8 text-muted-foreground text-sm">Signing you in…</div>;
}
